import vuex from "vuex";
import localStorage from "../../helper/localStorage";
import http from "../../helper/http";
import listbase from "./listbase";
import { merge, sortBy, flatten, reverse } from 'lodash'

const getters = {
    // userInfo: async () => {
    //     // if (state.state == undefined) {
    //     //     await mutations.changeUserInfoAsync();
    //     // }
    //     return state.userInfo;
    // }
}



const actions = {
    async loadDataList({ state, commit }, params) {
        commit('setInitStore', params);
        let dataList = await http.get(state.requestUrl, {
            params: merge({
                pageindex: state.pageindex,
                pagesize: state.pagesize,
            }, state.filterParams)
        });
        commit('setloadDataList', dataList);
    },
    initStore({ commit, dispatch }, params) {
        commit('setInitStore', params);
    },
    async  getOtherDataList({ }, url) {
        let dataList = await http.get(url);
        return dataList;
    }
}

const mutations = {
    /**
     * 加载数据
     * @param {*} state 
     * @param {*} v 
     */
    setloadDataList(state, v) {
        state.dataList = v.data;
        state.totalcount = v.count;
        state.totalcount = v.count;
        state.loading = false;
    },
    /**
     * 设置初始化参数
     * @param {*} state 
     * @param {*} params 
     */
    setInitStore(state, params) {
        state.filterParams = {};
        merge(state, params);
    }
}

export default merge(listbase({ requestUrl: '', requestMethod: 'get', pageindex: 1, pagesize: 30, pagecount: 0, totalcount: 0, filterParams: {}, dataList: [] }), {
    namespaced: true,
    listbase,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/dataListstorehelper.js